import {React, useEffect, useState} from 'react';
import { FaShoppingCart, FaStoreAltSlash, FaWallet, FaCreditCard, FaMoneyBillWave, FaChartLine, FaUsers, FaBoxes, FaTruck, FaCalendarAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './Customcss/home.css';
import axios from 'axios';
import CustomerChart from './Charts/CustomerChart';
import ProductChart from './Charts/ProductChart';
import MonthlyChart from './Charts/MonthlyChart';
import WeeklyChart from './Charts/WeeklyChart';

import BallTriangle from 'react-loading-icons/dist/esm/components/ball-triangle';
import { useStateContext } from './Context/ContextProvider';
import CustomerTable from './Dashboard Items/CustomerTable';

function Dashboard() {
  const [Stores, setStores] = useState([]);
  const [topCustomers, settopCustomers] = useState([]);
  const [monthwise, setmonthwise] = useState([]);
  const [productsdata, setproductsdata] = useState([]);
  const [weeklysale, setweeklysale] = useState([]);
  const [dailyExpense, setDailyExpense] = useState('0');
  const [monthlyExpense, setMonthlyExpense] = useState('0');
  const [dailyWasooli, setDailyWasooli] = useState('0');
  const [monthlyWasooli, setMonthlyWasooli] = useState('0');
  const [dailyUdhar, setDailyUdhar] = useState('0');
  const [monthlyUdhar, setMonthlyUdhar] = useState('0');
  const [Loading, setLoading] = useState(true);
  const { type } = useStateContext();
  const [inactiveCustomers, setInactiveCustomers] = useState([]);
  const [defaulters, setDefaulters] = useState([]);

  useEffect(() => {
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.get('/api/home').then(res => {
        setStores(res.data.stores);
        setmonthwise(res.data.monthwise);
        settopCustomers(res.data.customerwise);
        setproductsdata(res.data.productsdata);
        setweeklysale(res.data.weeklysale);
        setMonthlyExpense(res.data.monthlyTotalExpense);
        setDailyExpense(res.data.dailyExpense);
        setDailyWasooli(res.data.dailyTotalWasooli);
        setMonthlyWasooli(res.data.monthlyTotalWasooli);
        setDailyUdhar(res.data.dailyUdhar);
        setMonthlyUdhar(res.data.monthlyUdhar);
        setInactiveCustomers(res.data.inactiveCustomers);
        setDefaulters(res.data.defaulters);
        setLoading(false);
      });
    });
  }, []);

  if (type === 'Salesman') {
    return (
      <div className='salesman-dashboard'>
        <div className='stores-grid'>
          {Stores.length === 0 ? (
            <div className='loading-message'>Loading Stores...</div>
          ) : (
            Stores && Stores.map((item, index) => (
              <div className='store-card' key={item.id}>
                <Link to={`/productdetail/${item.id}`} className='store-link'>
                  <div className='store-icon'>
                    <FaStoreAltSlash />
                  </div>
                  <div className='store-name'>{item.name.slice(0, 12)}</div>
                </Link>
              </div>
            ))
          )}
        </div>
        <style>{`
          .salesman-dashboard {
            min-height: 100vh;
            background: linear-gradient(145deg, #f8f9fc 0%, #e9ecef 100%);
            padding: 30px;
          }
          .stores-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 25px;
            max-width: 1400px;
            margin: 0 auto;
          }
          .store-card {
            background: white;
            border-radius: 16px;
            padding: 30px 20px;
            text-align: center;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 4px 6px rgba(0,0,0,0.07);
            cursor: pointer;
          }
          .store-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 30px -12px rgba(0,0,0,0.15);
          }
          .store-icon {
            font-size: 48px;
            color: #dc3545;
            margin-bottom: 20px;
            transition: transform 0.3s ease;
          }
          .store-card:hover .store-icon {
            transform: scale(1.1);
          }
          .store-name {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            padding-top: 15px;
            border-top: 2px solid #f0f0f0;
          }
          .loading-message {
            text-align: center;
            padding: 50px;
            font-size: 18px;
            color: #666;
          }
          @media (max-width: 768px) {
            .salesman-dashboard {
              padding: 15px;
            }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="dashboard-main">
      <div className="dashboard-content">
        {/* Store Section */}
        <div className="store-section">
          <div className="section-header">
            <FaTruck className="section-icon" />
            <h2>Select Store</h2>
          </div>
          <div className="stores-wrapper">
            {Stores.map(store => (
              <Link to={`/saleentry/${store.id}`} key={store.id} className="store-card-modern">
                <FaShoppingCart className="store-icon-modern" />
                <span>{store.name}</span>
              </Link>
            ))}
          </div>
        </div>

        {Loading ? (
          <div className="loading-container">
            <BallTriangle stroke='#667eea' />
            <p>Loading Dashboard...</p>
          </div>
        ) : (
          <>
            {/* Stats Cards */}
            <div className="stats-grid">
              <div className="stat-card stat-card-1">
                <div className="stat-header">
                  <FaWallet className="stat-icon" />
                  <span className="stat-badge">Today</span>
                </div>
                <div className="stat-body">
                  <div className="stat-item">
                    <span className="stat-label">Collection</span>
                    <span className="stat-number">{dailyWasooli}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Credit</span>
                    <span className="stat-number">{dailyUdhar}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Expense</span>
                    <span className="stat-number">{dailyExpense}</span>
                  </div>
                </div>
                <div className="stat-footer">
                  <FaCalendarAlt />
                  <span>Today's Summary</span>
                </div>
              </div>

              <div className="stat-card stat-card-2">
                <div className="stat-header">
                  <FaMoneyBillWave className="stat-icon" />
                  <span className="stat-badge">This Month</span>
                </div>
                <div className="stat-body">
                  <div className="stat-item">
                    <span className="stat-label">Collection</span>
                    <span className="stat-number">{monthlyWasooli}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Credit</span>
                    <span className="stat-number">{monthlyUdhar}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Expense</span>
                    <span className="stat-number">{monthlyExpense}</span>
                  </div>
                </div>
                <div className="stat-footer">
                  <FaChartLine />
                  <span>Monthly Summary</span>
                </div>
              </div>

              <div className="stat-card stat-card-3">
                <div className="stat-header">
                  <FaCreditCard className="stat-icon" />
                  <span className="stat-badge">Overview</span>
                </div>
                <div className="stat-body">
                  <div className="stat-item-large">
                    <span className="stat-label">Net Profit</span>
                    <span className="stat-number-large">
                      {parseInt(monthlyWasooli) - parseInt(monthlyExpense)}
                    </span>
                  </div>
                  <div className="stat-item-large">
                    <span className="stat-label">Total Outstanding</span>
                    <span className="stat-number-large">{monthlyUdhar}</span>
                  </div>
                </div>
                <div className="stat-footer">
                  <FaUsers />
                  <span>Business Overview</span>
                </div>
              </div>
            </div>

            {/* Customer Tables */}
            <div className="tables-container">
              <div className="table-card">
                <div className="table-card-header warning-header">
                  <FaUsers className="header-icon" />
                  <h3>Inactive Customers (90+ days)</h3>
                  <span className="customer-count">{inactiveCustomers.length}</span>
                </div>
                <div className="table-card-body">
                  <CustomerTable 
                    customers={inactiveCustomers} 
                    type={1} 
                  />
                </div>
              </div>

              <div className="table-card">
                <div className="table-card-header danger-header">
                  <FaUsers className="header-icon" />
                  <h3>Defaulters (30+ days overdue)</h3>
                  <span className="customer-count">{defaulters.length}</span>
                </div>
                <div className="table-card-body">
                  <CustomerTable 
                    customers={defaulters} 
                    type={2} 
                  />
                </div>
              </div>
            </div>

            {/* Charts Section */}
            {type !== 'Salesman' && (
              <>
                <div className="charts-grid">
                  <div className="chart-card">
                    <div className="chart-header">
                      <FaChartLine className="chart-icon" />
                      <h4>Weekly Sales Trend</h4>
                    </div>
                    <div className="chart-body">
                      <WeeklyChart datas={weeklysale} />
                    </div>
                  </div>
                  <div className="chart-card">
                    <div className="chart-header">
                      <FaUsers className="chart-icon" />
                      <h4>Top Customers</h4>
                    </div>
                    <div className="chart-body">
                      <CustomerChart datas={topCustomers} />
                    </div>
                  </div>
                </div>

                <div className="charts-grid">
                  <div className="chart-card">
                    <div className="chart-header">
                      <FaCalendarAlt className="chart-icon" />
                      <h4>Monthly Performance</h4>
                    </div>
                    <div className="chart-body">
                      <MonthlyChart data={monthwise} />
                    </div>
                  </div>
                  <div className="chart-card">
                    <div className="chart-header">
                      <FaBoxes className="chart-icon" />
                      <h4>Top Products</h4>
                    </div>
                    <div className="chart-body">
                      <ProductChart data={productsdata} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <style>{`
        .dashboard-main {
          min-height: 100vh;
         background: white;
          position: relative;
        }
        
        .dashboard-main::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="rgba(255,255,255,0.05)" fill-opacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>') no-repeat bottom;
          background-size: cover;
          opacity: 0.3;
          pointer-events: none;
        }
        
        .dashboard-content {
          position: relative;
          z-index: 1;
          padding: 25px 30px;
          max-width: 1600px;
          margin: 0 auto;
        }
        
        /* Store Section */
        .store-section {
          background: rgba(255,255,255,0.95);
          border-radius: 20px;
          padding: 20px;
          margin-bottom: 30px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          backdrop-filter: blur(10px);
        }
        
        .section-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #f0f0f0;
        }
        
        .section-icon {
          font-size: 24px;
          color: #667eea;
        }
        
        .section-header h2 {
          font-size: 20px;
          margin: 0;
          color: #333;
        }
        
        .stores-wrapper {
          display: flex;
          gap: 15px;
          overflow-x: auto;
          padding: 10px 5px;
        }
        
        .stores-wrapper::-webkit-scrollbar {
          height: 6px;
        }
        
        .stores-wrapper::-webkit-scrollbar-track {
          background: #e0e0e0;
          border-radius: 10px;
        }
        
        .stores-wrapper::-webkit-scrollbar-thumb {
          background: #667eea;
          border-radius: 10px;
        }
        
        .store-card-modern {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 24px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          text-decoration: none;
          color: white;
          transition: all 0.3s ease;
          white-space: nowrap;
        }
        
        .store-card-modern:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(102,126,234,0.3);
        }
        
        .store-icon-modern {
          font-size: 18px;
        }
        
        /* Loading */
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          background: rgba(255,255,255,0.95);
          border-radius: 20px;
          padding: 50px;
        }
        
        .loading-container p {
          margin-top: 20px;
          color: #667eea;
          font-weight: 500;
        }
        
        /* Stats Grid */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 25px;
          margin-bottom: 35px;
        }
        
        .stat-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .stat-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }
        
        .stat-card-1 {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }
        
        .stat-card-2 {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          color: white;
        }
        
        .stat-card-3 {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          color: white;
        }
        
        .stat-header {
          padding: 20px 20px 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .stat-icon {
          font-size: 28px;
          opacity: 0.9;
        }
        
        .stat-badge {
          background: rgba(255,255,255,0.2);
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }
        
        .stat-body {
          padding: 0 20px;
        }
        
        .stat-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255,255,255,0.2);
        }
        
        .stat-item:last-child {
          border-bottom: none;
        }
        
        .stat-label {
          font-size: 14px;
          opacity: 0.9;
        }
        
        .stat-number {
          font-size: 20px;
          font-weight: bold;
        }
        
        .stat-item-large {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 0;
        }
        
        .stat-number-large {
          font-size: 28px;
          font-weight: bold;
        }
        
        .stat-footer {
          padding: 15px 20px;
          background: rgba(0,0,0,0.1);
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 13px;
        }
        
        /* Tables Container */
        .tables-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
          gap: 25px;
          margin-bottom: 35px;
        }
        
        .table-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        
        .table-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }
        
        .table-card-header {
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 12px;
          border-bottom: 3px solid;
        }
        
        .warning-header {
          background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
          border-bottom-color: #ff9800;
        }
        
        .danger-header {
          background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
          border-bottom-color: #f44336;
        }
        
        .header-icon {
          font-size: 24px;
        }
        
        .warning-header .header-icon {
          color: #ff9800;
        }
        
        .danger-header .header-icon {
          color: #f44336;
        }
        
        .table-card-header h3 {
          margin: 0;
          flex: 1;
          font-size: 16px;
          font-weight: 600;
        }
        
        .customer-count {
          background: rgba(0,0,0,0.1);
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: bold;
        }
        
        .table-card-body {
          max-height: 400px;
          overflow-y: auto;
        }
        
        .table-card-body::-webkit-scrollbar {
          width: 8px;
        }
        
        .table-card-body::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        .table-card-body::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        
        .table-card-body::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        
        /* Charts Grid */
        .charts-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
          gap: 25px;
          margin-bottom: 35px;
        }
        
        .chart-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        
        .chart-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }
        
        .chart-header {
          padding: 20px;
          background: linear-gradient(135deg, #f8f9fc 0%, #e9ecef 100%);
          display: flex;
          align-items: center;
          gap: 12px;
          border-bottom: 2px solid #e0e0e0;
        }
        
        .chart-icon {
          font-size: 22px;
          color: #667eea;
        }
        
        .chart-header h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
        
        .chart-body {
          padding: 20px;
        }
        
        /* Responsive */
        @media (max-width: 1200px) {
          .tables-container {
            grid-template-columns: 1fr;
          }
        }
        
        @media (max-width: 992px) {
          .charts-grid {
            grid-template-columns: 1fr;
          }
        }
        
        @media (max-width: 768px) {
          .dashboard-content {
            padding: 15px;
          }
          
          .stats-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          
          .stat-number-large {
            font-size: 22px;
          }
        }
      `}</style>
    </div>
  );
}

export default Dashboard;